var React = require('react');

function MortarPestle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M501.54 60.91L402.46 160H251.09L454.9 7.14a35.68 35.68 0 0 1 46.64 53.77z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M16 192h480a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-16c0 81-50.2 150.11-121.13 178.32A128.08 128.08 0 0 1 383.82 493a16.43 16.43 0 0 1-16.07 19h-223.5a16.43 16.43 0 0 1-16.07-19 128.29 128.29 0 0 1 24.95-58.69C82.2 406.11 32 337 32 256H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16z","className":"fa-primary","key":2})]);
}

MortarPestle.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = MortarPestle;

MortarPestle.default = MortarPestle;
